import React from 'react'
import './styles.scss'

export default ({ cost }) => (
  <div className='download-cost center-child indicator'>
    <span>Total Cost</span>
    <span>$ {cost ? cost.toFixed(5) : 0.00000}</span>
  </div>
)
